/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_STATUS = "APPROVED" | "NONE" | "PREMOD" | "REJECTED" | "SYSTEM_WITHHELD" | "%future added value";
export type DSAReportDecisionLegality = "ILLEGAL" | "LEGAL" | "%future added value";
export type NOTIFICATION_TYPE = "COMMENT_APPROVED" | "COMMENT_FEATURED" | "COMMENT_REJECTED" | "DSA_REPORT_DECISION_MADE" | "ILLEGAL_REJECTED" | "PREVIOUSLY_REJECTED_COMMENT_APPROVED" | "REPLY" | "REPLY_STAFF" | "UNKNOWN" | "%future added value";
export type REJECTION_REASON_CODE = "ABUSIVE" | "AD" | "BANNED_WORD" | "HARASSMENT_BULLYING" | "HATE_SPEECH" | "ILLEGAL_CONTENT" | "IRRELEVANT_CONTENT" | "MISINFORMATION" | "OFFENSIVE" | "OTHER" | "SPAM" | "%future added value";
export type RejectedCommentNotificationBody_notification = {
    readonly type: NOTIFICATION_TYPE | null;
    readonly rejectionReason: REJECTION_REASON_CODE | null;
    readonly customReason: string | null;
    readonly previousStatus: COMMENT_STATUS | null;
    readonly decisionDetails: {
        readonly legality: DSAReportDecisionLegality | null;
        readonly grounds: string | null;
        readonly explanation: string | null;
    } | null;
    readonly comment: {
        readonly " $fragmentRefs": FragmentRefs<"NotificationCommentContainer_comment">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"NotificationCommentContainer_notification">;
    readonly " $refType": "RejectedCommentNotificationBody_notification";
};
export type RejectedCommentNotificationBody_notification$data = RejectedCommentNotificationBody_notification;
export type RejectedCommentNotificationBody_notification$key = {
    readonly " $data"?: RejectedCommentNotificationBody_notification$data;
    readonly " $fragmentRefs": FragmentRefs<"RejectedCommentNotificationBody_notification">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RejectedCommentNotificationBody_notification",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rejectionReason",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customReason",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "previousStatus",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "NotificationDecisionDetails",
            "kind": "LinkedField",
            "name": "decisionDetails",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "legality",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "grounds",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "explanation",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "comment",
            "plural": false,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "NotificationCommentContainer_comment"
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NotificationCommentContainer_notification"
        }
    ],
    "type": "Notification",
    "abstractKey": null
} as any);
(node as any).hash = '78278e3b83ef2ec895e8e9f85b516916';
export default node;
